/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useResize } from '../../hooks'
import PropTypes from 'prop-types'
import { IoSearchOutline, BsChevronLeft, IoCloseOutline } from 'react-icons/all';
import {  Container, 
          FormContainer, 
          Form, 
          InputText, 
          ContainerSearchIcon, 
          ReturnMobile, 
          Contador, 
          ContadorText,
          MiniLogoContainer,
          CloseButton 
} from './index.styled'
import { connect } from 'react-redux';

const SearchBar = React.memo(({ funcBack = () => console.log("back"), placeholder = "", onSearch = () => {}, results = [], locale }) => {
  const intl = useIntl();
  const isMobile = useResize().isMobile
  const [ message, setMessage ] = useState('')
  const [ textInput, setTextInput ] = useState('')
  const [ showCloseButton, setShowCloseButton ] = useState(false);
  const [localeS, setLocaleS] = useState(locale)

  const foundText = intl.formatMessage({ id: "found" })
  const totalText = intl.formatMessage({ id: "total" })
  const searchText = intl.formatMessage({ id: "search" })

  const defaultMessage = `${results.length} ${totalText} ${placeholder} ${foundText}`;

  const handleSearch = (e) => {
    e.preventDefault();
    if(textInput === "" || textInput.length > 2){
      onSearch(textInput)
    }
  }

  const closeSearch = () => {
    setMessage(defaultMessage)
    setShowCloseButton(false)
  }

  useEffect(() => {
    setMessage(defaultMessage)
  }, [])


  useEffect(() => {
    setMessage(`${results.length} ${totalText} ${placeholder} ${foundText}`)
  }, [results])

  useEffect(() => {
    if(locale !== localeS){
      setLocaleS(locale)
      setMessage(defaultMessage)
    }
  }, [locale])

  return (
    <Container>
      <ReturnMobile onClick={() => funcBack(null)}>
        <BsChevronLeft size={32} />
      </ReturnMobile>
      <FormContainer>
        <Form onSubmit={handleSearch}>
          <ContainerSearchIcon>
            <IoSearchOutline onClick={handleSearch}/>
          </ContainerSearchIcon>
          {showCloseButton && isMobile &&
              <CloseButton className="mobile">
                <IoCloseOutline size={28} onClick={closeSearch} />
              </CloseButton>
          }
          <InputText type="text" onChange={event => setTextInput(event.target.value)} value={textInput} placeholder={`${searchText} ${placeholder}`} />
        </Form>
      </FormContainer>
      {!isMobile && <MiniLogoContainer />}
      {!isMobile &&
      <Contador key={message}>
        <ContadorText>{message}</ContadorText>
        {showCloseButton && 
          <CloseButton>
            <IoCloseOutline size={36} onClick={closeSearch} />
          </CloseButton>
        }
      </Contador>
      }
    </Container>
  )
})

SearchBar.propTypes = {
  placeholder: PropTypes.string
}

SearchBar.defaultProps = {
  placeholder: "panoramas"
}

const mapStateToProps = ({ app }) => {
  const {
    locale
  } = app

  return {
    locale
  }
}
export default connect(mapStateToProps, null)(React.memo(SearchBar))
